import { Component, OnInit, inject } from '@angular/core';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {TranslationService} from '../../../core/services/translation.service';
import {BaseDataService} from '../../../core/services/base-data.service';
import {SubChangeService} from '../../../data/services/sub-change.service';
import {HupSubscriptionsService} from '../../../data/services/hup-subscriptions.service';
import {ErrorService} from '../../../core/components/general-errors/error.service';
import {MatStep, MatStepLabel, MatStepper, MatStepperNext, MatStepperPrevious} from '@angular/material/stepper';
import {HupSubscription} from '../../../data/models/subscription.model';
import {ActivatedRoute} from '@angular/router';
import {SubChangeType, SubChangeTypeEnum} from '../../../data/models/sub-change-type.model';
import {BaseData} from '../../../data/models/base-data.model';
import {ConfigService} from '../../../core/services/config.service';
import {Observable} from 'rxjs';
import {StepperOrientation} from '@angular/cdk/stepper';
import {BreakpointObserver} from '@angular/cdk/layout';
import {map} from 'rxjs/operators';
import {SnackbarService} from '../../../core/services/snackbar.service';
import {NavigationCommand, NavigationService} from '../../../data/services/navigation.service';
import {OfferPrice} from '../../../data/models/price.model';
import {DonationPool} from '../../../data/models/donation-pool.model';

import {AddressCode} from "../../../data/models/address-code.model";
import {DateAdapter, MatOption, provideNativeDateAdapter} from '@angular/material/core';
import {GeneralErrorsComponent} from "../../../core/components/general-errors/general-errors.component";
import {LoadingSpinnerComponent} from "../../../core/components/loading-spinner/loading-spinner.component";
import { AsyncPipe, DatePipe, JsonPipe } from "@angular/common";
import {MatError, MatFormField, MatFormFieldModule, MatLabel} from "@angular/material/form-field";
import {
  MatDatepickerModule,
  MatDatepickerToggle,
  MatDateRangeInput,
  MatDateRangePicker
} from "@angular/material/datepicker";
import {MatSelect} from "@angular/material/select";
import {MatButton} from "@angular/material/button";
import {
  HupSubscriptionAddressComponent
} from "../../hup-subscription/hup-subscription-detail/hup-subscription-address/hup-subscription-address.component";
import {MatCheckbox} from "@angular/material/checkbox";
import {MatDivider} from "@angular/material/divider";
import {HouseNoPipe} from "../../../core/pipes/houseno.pipe";
import {MatIcon} from "@angular/material/icon";
import {ApplyIfNotEmptyDirective} from "../../../core/directives/apply-if-not-empty.directive";
import {getHouseNo, transformHouseNo} from "../../../core/utils/address-utils";
import {GeneralWarningComponent} from "../../../core/components/general-warning/general-warning.component";

@Component({
  selector: 'app-sub-change-edit',
  templateUrl: './sub-change-edit.component.html',
  styleUrls: ['./sub-change-edit.component.scss'],
  providers: [provideNativeDateAdapter()],
  imports: [
    GeneralErrorsComponent,
    LoadingSpinnerComponent,
    MatStepper,
    AsyncPipe,
    MatStep,
    ReactiveFormsModule,
    MatFormField,
    MatDateRangeInput,
    MatDatepickerToggle,
    MatDateRangePicker,
    MatSelect,
    MatOption,
    MatButton,
    MatStepperNext,
    MatStepLabel,
    HupSubscriptionAddressComponent,
    MatCheckbox,
    MatStepperPrevious,
    GeneralWarningComponent,
    DatePipe,
    MatDivider,
    HouseNoPipe,
    MatIcon,
    MatLabel,
    MatError,
    MatFormFieldModule,
    MatDatepickerModule,
    FormsModule,
    ReactiveFormsModule,
    ApplyIfNotEmptyDirective
  ],
  standalone: true
})
export class SubChangeEditComponent implements OnInit {
  translationService = inject(TranslationService);
  private formBuilder = inject(FormBuilder);
  private baseDataService = inject(BaseDataService);
  private subChangeService = inject(SubChangeService);
  private hupSubscriptionsService = inject(HupSubscriptionsService);
  private errorService = inject(ErrorService);
  private route = inject(ActivatedRoute);
  private configService = inject(ConfigService);
  private breakpointObserver = inject(BreakpointObserver);
  private snackBar = inject(SnackbarService);
  private navigationService = inject(NavigationService);
  private dateAdapter = inject<DateAdapter<Date>>(DateAdapter);

  isMobile: boolean = false;  // TODO: Berechnung
  minDate: Date = new Date();
  maxDate: Date = null;
  sub: HupSubscription;
  subChangeTypeForm: FormGroup;
  collectDataForm: FormGroup;
  forwardDataForm: FormGroup;
  donationDataForm: FormGroup;
  ePaperDataForm: FormGroup;
  intermissionDataForm: FormGroup;
  errorsArr: string[] = [];
  warningsArr: string[] = [];
  isLoadingSub: boolean = false;
  isLoading: boolean = false;
  countries: BaseData[] = [];
  salutations: AddressCode[] = [];
  titles: BaseData[] = [];
  public donationPools: DonationPool[];
  donationBoolError: boolean = false;
  enableAdditionalExemplar: boolean;

  offerPrice: OfferPrice;
  priceCheckError = false;
  subChangeTypes: SubChangeType[] = [];
  changeable: boolean = true;
  saving: boolean = false;
  subChange;
  showBackToOverviewButton: boolean;
  userHouseNo: string;
  priceCheckFinished: boolean = false;
  referenceFormValues: any;
  referenceSubChangeTypeValues: any;
  formSubmitted = false;
  zeroPrice = '0.0';
  unauthorized: boolean = false;
  userBackendId: number = -1;
  maxIntermissionDays: number = 999;

  stepperOrientation: Observable<StepperOrientation>;
  currentDate: Date = new Date();

  subBackendId: number;
  changeWebId: number;
  changeBackendId: number;

  constructor() {
  const breakpointObserver = this.breakpointObserver;
  this.dateAdapter.getFirstDayOfWeek = () => 1;
    this.stepperOrientation = breakpointObserver
      .observe('(min-width: 800px)')
      .pipe(map(({matches}) => (matches ? 'horizontal' : 'vertical')));

    this.enableAdditionalExemplar = this.configService.getConfig('subchange.enable.additional.exemplar')?.asBoolean();

    this.showBackToOverviewButton = this.configService.getConfig('show.backToOverView.button')?.asBoolean();

    const _maxIntermissionDays = this.configService.getConfig('SUBMAXINTERMISSIONDAYS');
    if (_maxIntermissionDays != null && _maxIntermissionDays.value) {
      try {
        const maxDays = Number(_maxIntermissionDays.value);
        if (maxDays <= 0) return;
        this.maxIntermissionDays = maxDays;
      } catch (e) {
        console.error('Error parsing SUBMAXINTERMISSIONDAYS', e);
      }
    }
  }

  updateMaxDate(referenceDate: Date): void {
    if (referenceDate) {
      let result: Date = new Date(referenceDate);
      // -1, da der heutige Tag ja schon dazuzählt.
      result.setDate(referenceDate.getDate() + (this.maxIntermissionDays - 1));
      this.maxDate = result;
    } else {
      const tempDate = new Date();
      tempDate.setDate(tempDate.getDate() + 999);
      this.maxDate = tempDate;
    }
  }

  ngOnInit(): void {
    this.subChange = null;

    this.isLoadingSub = true;
    this.countries = this.baseDataService.getBaseData('countrycodes');
    this.salutations = this.baseDataService.getBaseData('addresscodes');
    this.titles = this.baseDataService.getBaseData('titles');

    this.buildForms();

    this.route.paramMap.subscribe((params) => {
      if(params.get('unauthorized') === 'true') {
        this.unauthorized = true;
        this.userBackendId = Number(params.get('clientNo'));
        this.sub = new HupSubscription(Number(params.get('subBackendId')), this.userBackendId, 0, Number(params.get('subBackendId')), false, null, params.get('variant'), null, null, null, null, null, null, null, null, null, null, null, null, false, params.get('product'), null, null, null);

        this.forwardDataForm.get('subId').patchValue(this.sub.backendId);
        this.hupSubscriptionsService.getNextDeliveryDate(this.sub.productCode, this.sub.variantCode).subscribe(date => {
          this.setMinDate(date);
        });

        this.subBackendId = +params.get('subBackendId');
        this.changeWebId = +params.get('changeWebId');
        this.changeBackendId = +params.get('changeBackendId');
      } else {
        this.hupSubscriptionsService.getSubscription('0', params.get('subBackendId')).subscribe(sub => {
          this.sub = sub;
          this.isLoadingSub = false;
          // set value in form?
          this.forwardDataForm.get('subId').patchValue(sub.backendId);

          this.hupSubscriptionsService.getNextDeliveryDate(sub.productCode, sub.variantCode).subscribe(date => {
            this.setMinDate(date);
          });

          this.subBackendId = +params.get('subBackendId');
          this.changeWebId = +params.get('changeWebId');
          this.changeBackendId = +params.get('changeBackendId');
        });
      }

      this.changeable = params.get('changeable') !== 'false';
    });
  }

  loadChangeTypesAndSubChange(subBackendId: number, changeWebId: number, changeBackendId: number): void {
    this.subChangeTypes = [];
    this.subChangeService.getSubChangeTypes(subBackendId).subscribe(typesAllowed => {
      // und was ist mit sammeln...? {key: 1, code: 'COLLECT'},
      if (typesAllowed.donationAllowed && !this.donationBoolError) {
        this.subChangeTypes.push({key: SubChangeTypeEnum.DONATION_POOL, code: 'DONATION', description: 'Spende'});
      }
      if (typesAllowed.epaperReplacementAllowed) {
        this.subChangeTypes.push({key: SubChangeTypeEnum.EPAPER, code: 'EPAPER', description: 'Epaper'});
      }
      if (typesAllowed.forwardAllowed) {
        this.subChangeTypes.push({key: SubChangeTypeEnum.FORWARD, code: 'FORWARD', description: 'Nachlieferung'});
      }
      if (typesAllowed.intermissionAllowed) {
        this.subChangeTypes.push({
          key: SubChangeTypeEnum.INTERMISSION,
          code: 'INTERMISSION',
          description: 'Unterbrechung'
        });
      }
      if (changeWebId > 0 || changeBackendId > 0) {
        this.subChangeService.getSubChange(changeWebId, changeBackendId, subBackendId).subscribe(subChange => {
          this.subChange = subChange;
          this.setFormData(subChange);
          const isInPast = new Date(subChange.validDate.validFrom).getTime() <= new Date().getTime();
          const isInParadise = subChange.backendId > 0;
          this.disableForms(isInPast, isInParadise);
        });
      }
    });
  }

  setFormData(subChange): void {
    const typeKey = SubChangeTypeEnum[subChange.changeType];

    let changeType = {};
    this.subChangeTypes.forEach(type => {
      if (type.key.toString() === typeKey.toString()) {
        changeType = type;
      }
    });
    this.subChangeTypeForm.patchValue(subChange);
    this.subChangeTypeForm.get('changeType').patchValue(changeType);
    this.collectDataForm.patchValue(subChange);
    this.forwardDataForm.patchValue(subChange);
    if (subChange.person && subChange.address) {
      this.forwardDataForm.get('person.firstName').setValue(subChange.person.firstname);
      this.forwardDataForm.get('person.lastName').setValue(subChange.person.lastname);
      this.forwardDataForm.get('address.houseNo').setValue(transformHouseNo(subChange.address.houseno));
    }
    this.donationDataForm.patchValue(subChange);
    this.ePaperDataForm.patchValue(subChange);
    this.intermissionDataForm.patchValue(subChange);
  }

  disableForms(isInPast, isInParadise): void {
    if (isInParadise) {
      this.subChangeTypeForm.get('changeType').disable();
    }
    if ( isInPast ) {
      this.subChangeTypeForm.get('changeType').disable();
      this.subChangeTypeForm.get('validDate').disable();
      this.forwardDataForm.disable();
      this.donationDataForm.disable();
      this.ePaperDataForm.disable();
      this.intermissionDataForm.disable();
    }
    if (!this.changeable) {
      this.collectDataForm.disable();
    }
  }

  buildForms(): void {
    this.subChangeTypeForm = this.formBuilder.group({
      validDate: this.formBuilder.group({
        validFrom: ['', Validators.required],
        validUntil: ['', Validators.required],
      }),
      changeType: ['', Validators.required] // -> donation, collectShipment, imermission, epaper, forward?
    });

    this.subChangeTypeForm.get('validDate').valueChanges.subscribe(change => {
      // Enddate Dynamisch setzen!
        this.updateMaxDate(change['validFrom']);
        this.loadDonationPools(change['validFrom'], change['validUntil']);
    });

    this.collectDataForm = this.formBuilder.group({
      // Collection Adresse
    });

    this.forwardDataForm = this.formBuilder.group({
      subId: ['', Validators.required],
      address: this.formBuilder.group({
        country: [''],
        zipcode: [''],
        city: [''],
        street: [''],
        houseNo: [''],
        extraLine: [''],
        houseNoExt: [''],
        stiege: [''],
        stock: [''],
        tuer: [''],
        district: ['']
      }),
      person: this.formBuilder.group({
        title: [''],
        salutation: [''],
        firstName: [''],
        lastName: [''],
        initials: [''],
        middlename: ['']
      }),
      additional: ['']
    });

    // TODO: Andere Imermission Fälle
    this.donationDataForm = this.formBuilder.group({
      // Pool, Privat oder Öffentl.
      // evtl. Adresse eingeben
    });

    this.ePaperDataForm = this.formBuilder.group({
      // ggf. Ausgaben Wahl // TODO: Ausgabenliste
    });

    this.intermissionDataForm = this.formBuilder.group({
      // Keine weiteren Angaben, aber ggf. Berechnung der Erstattung
    });
  }

  onSend(stepper: MatStepper): void {
    this.saving = true;
    const data = this.getFormData();
    this.saving = true;

    if (this.subChange) {
      this.subChangeService.updateSubChange(data, this.subChange.webId, this.subChange.subId, this.subChange.backendId)
        .subscribe(res => {
            this.navigateToOverview();
          },
          error => {
            this.errorsArr = [];
            this.errorService.handleAPIError([
              this.intermissionDataForm,
              this.forwardDataForm,
              this.ePaperDataForm,
              this.collectDataForm,
              this.subChangeTypeForm,
              this.donationDataForm
            ], error.error, this.errorsArr, stepper);
            this.saving = false;
          },
          () => {
            this.saving = false;
          });
    } else {
      this.subChangeService.sendSubChange(data, this.unauthorized).subscribe(res => {
          this.navigateToOverview();
        }, error => {
          this.errorsArr = [];
          const errorObj = JSON.parse(error?.error?.message);
          for (const key in errorObj) {
            this.errorsArr.push(errorObj[key]);
          }
          this.saving = false;
        },
        () => this.saving = false);
    }
  }

  private navigateToOverview() {
    let params: string[] = [];
    let navigateTo: NavigationCommand = NavigationCommand.SUBCHANGE
    if(this.unauthorized) {
      navigateTo = NavigationCommand.SUBCHANGEWITHOUTLOGINAFTER;
    }
    this.navigationService.navigateTo(navigateTo, params).then((navigated) => {
      if (navigated) {
        this.snackBar.openSnackbar(this.translationService.getTranslation('saved'));
      }
    });
  }

  getPriceForSubChange(stepper: MatStepper): void {
      if (stepper.steps.get(stepper.selectedIndex) === stepper.steps.last && this.changeable) {
        this.getPriceForType(this.changeable);
    }
  }

  getPriceForType(changeable:boolean) {
    if (changeable) {
      this.isLoading = true;
      const formData = this.getFormData();
      this.priceCheckFinished = false;

      this.submitForm();
      this.resetWarnings();

      //todo: Price for SubChangeTypeEnum.INTERMISSION - wird doch (irgendwann) benötigt?
      if (formData.changeType == SubChangeTypeEnum.FORWARD) {
        this.subChangeService.getPriceForSubChange(formData, this.unauthorized).subscribe({
          next: (price) => {
            this.isLoading = false;
            let warning: string = '';

            if (price) {
              this.offerPrice = price;
              const paymentWarning = this.translationService.getTranslation('forwarding.new_price') + this.offerPrice?.price + ' ' + this.offerPrice?.currency + '.';
              const creditWarning = this.translationService.getTranslation('forwarding.credit_message').replace('%s', this.offerPrice.credit + ' ' + this.offerPrice.currency);
              warning = this.offerPrice?.credit <= 0.0 ? paymentWarning : creditWarning;
            } else {
              warning = this.translationService.getTranslation('forwarding.zero_price');
            }

            if (warning && warning !== '') {
              this.warningsArr.push(warning);
            }
            this.priceCheckFinished = true;
          },
          error: (error) => {
            this.isLoading = false;
            this.errorsArr = [];
            if (error?.error?.message) {
              const errorObj = JSON.parse(error?.error?.message);
              for (const key in errorObj) {
                this.errorsArr.push(errorObj[key]);
              }
            }
            const warning = this.translationService.getTranslation('error_subchanges_price_calculation');
            if (warning && warning !== '') {
              this.warningsArr.push(warning);
            }
            this.priceCheckFinished = true;
            this.priceCheckError = true;
          }
        });
      } else {
        this.priceCheckFinished = true;
        this.isLoading = false;
      }
    }
  }

  getFormData(): any {
    const data = {
      ...this.intermissionDataForm.value,
      ...this.forwardDataForm.value,
      ...this.ePaperDataForm.value,
      ...this.collectDataForm.value,
      ...this.subChangeTypeForm.value,
      ...this.donationDataForm.value
    };

    if (this.forwardDataForm.get('person.title').value) {
      data.person.title = this.forwardDataForm.get('person.title').value.key;
    }

    if (this.forwardDataForm.get('person.salutation').value) {
      if(this.forwardDataForm.get('person.salutation').value.defaultClientTypeKey) {
        data.person.salutation = this.forwardDataForm.get('person.salutation').value.defaultClientTypeKey;
      } else {
        data.person.salutation = this.forwardDataForm.get('person.salutation').value;
      }
    }

    if (this.forwardDataForm.get('address.country').value) {
      data.address.country = this.forwardDataForm.get('address.country').value.key;
    }

    if (this.forwardDataForm.get('person.firstName').value) {
      data.person.firstname = data.person.firstName;
    }

    if (this.forwardDataForm.get('person.lastName').value) {
      data.person.lastname = data.person.lastName;
    }

    if (this.forwardDataForm.get('address.houseNo').value) {
      if (this.forwardDataForm.get('address.country').value.key === 'A' ||
        this.forwardDataForm.get('address.country').value.key === 'AT') {
        data.address.houseno = getHouseNo(data.address.houseNo, data.address.country, data.address.stock, data.address.stiege, data.address.tuer);
      } else {
        data.address.houseno = getHouseNo(data.address.houseNo, data.address.country);
      }
      this.userHouseNo = data.address.houseno;
    }

    if (data?.changeType) {
      data.changeType = data.changeType.key;
    }

    if (this.offerPrice?.price) {
      data.price = this.offerPrice.price;
    }

    if (this.forwardDataForm.get('address.extraLine').value) {
      data.address.addrExtraLine1 = data.address.extraLine;
    }

    if (this.subChangeTypeForm.get('changeType').value.code === 'DONATION' && this.donationPools.length === 1) {
      data.donationPool = this.donationPools[0].key;
    }

    if(this.userBackendId > 0) {
      data.userBackendId = this.userBackendId;
    }

    if(this.subChange && this.subChange.webId > 0) {
      data.webId = this.subChange.webId;
    }
    return data;
  }

  /**
   * Define if there is only one donation pool
   */
  isDonationImpossible(subBackendId: number, changeWebId: number, changeBackendId: number, validFrom: any, validUntil: any): void {
    let startDate = null;
    let endDate = null;
    if (validFrom && validFrom !== '' && !(validFrom instanceof Date)) {
      startDate = validFrom.toDate();
    } else {
      startDate = validFrom;
    }
    if (validUntil && validUntil !== '' && !(validUntil instanceof Date)) {
      endDate = validUntil.toDate();
    } else {
      endDate = validUntil;
    }
    this.subChangeService.getDonationPools(this.sub.productCode, this.sub.variantCode, startDate, endDate).subscribe(
      (dp) => {
        this.donationPools = dp;
        this.donationBoolError = this.donationPools === null || this.donationPools === undefined || this.donationPools.length !== 1;
        if (this.donationPools === null || this.donationPools === undefined) {
          console.debug(this.translationService.getTranslation('subchange.donation.impossible') + ' (no Pools configured)');
        } else if (this.donationPools.length !== 1) {
          console.debug(this.translationService.getTranslation('subchange.donation.impossible') + ' (more then one pool configured)');
        }

        this.loadChangeTypesAndSubChange(subBackendId, changeWebId, changeBackendId);
      },
      (error) => {
        console.error('Error fetching donation pools', error);
      }
    );
  }

  hasFormChanges(): boolean {
    if (!this.formSubmitted) {
      return false;
    }
    return JSON.stringify(this.forwardDataForm.value) != JSON.stringify(this.referenceFormValues) ||
      JSON.stringify(this.subChangeTypeForm.get('validDate').value) != JSON.stringify(this.referenceSubChangeTypeValues);
  }

  submitForm() {
    if(this.forwardDataForm.valid) {
      this.referenceFormValues = {...this.forwardDataForm.value};
      this.referenceSubChangeTypeValues = {...this.subChangeTypeForm.get('validDate').value};
      this.formSubmitted = true;
    }
  }

  resetWarnings() {
      this.warningsArr = [];
  }

  backToOverview(): void {
    //window.location.href = 'https://abo.siegener-zeitung.de';
    this.navigationService.navigateTo(NavigationCommand.SUBCHANGE, null, true);
  }

  setMinDate(nextDeliveryDate: Date): void {
    if (nextDeliveryDate) {
      const now = new Date();
      now.setDate(now.getDate() + 1);
      this.minDate = now.getTime() <= nextDeliveryDate.getTime() ? nextDeliveryDate : now;
    }
  }

  loadDonationPools(validFrom: Date, validUntil: Date) {
    if( validFrom && validUntil) {
      this.isDonationImpossible(this.subBackendId, this.changeWebId, this.changeBackendId, validFrom, validUntil);
    }
  }

}
